module.exports = __webpack_public_path__ + "static/img/PC-4.4d6d822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-4.png
// module id = M1Zv
// module chunks = 0